import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useStore from "../store/useStore";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import EventDetailContent from "../components/EventDetailContent";

export default function EventDetail() {
  const { slug } = useParams();
  const { eventos, fetchEventos } = useStore();

  useEffect(() => {
    fetchEventos();
  }, [fetchEventos]);

  // Buscar el evento por slug
  const evento = (eventos || []).find((item) => item.slug === slug);

  if (!evento) {
    return (
      <>
        <Navbar />
        <div className="container py-24 text-center bg-sidom-light dark:bg-sidom-blue">
          <div className="flex flex-col items-center justify-center w-full h-screen">
            <h1 className="text-2xl font-bold">Cargando o no encontrado...</h1>
          </div>
        </div>
        <Footer />
        <Switcher />
      </>
    );
  }

  return (
    <>
      <header>
        <Navbar />
      </header>
      <main>
        <EventDetailContent evento={evento} />
      </main>
      <footer>
        <Footer />
      </footer>
      <Switcher />
    </>
  );
}
